export default __webpack_public_path__ + "static/media/ill-need-help.e80c8efd.svg";